import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import axios from "axios";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg"; // your custom arrow

import { getCookie } from "../../getcookie";
import { X } from "lucide-react";
const SearchableDropdown = ({
  apiUrl,
  placeholder,
  value,
  onSelect,
  handleClear,
}) => {
  const [options, setOptions] = useState([]);

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    setLoading(true);

    try {
      if (apiUrl) {
        const response = await axios.get(apiUrl, {
          params: { term: search },
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: getCookie("mawalog"),
          },
        });

        if (response.status === 200 && response.data.success) {
          setOptions(response.data.suggestionlist);
        } else {
          setOptions([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [apiUrl, search]);

  // Filter options based on search

  return (
    <Dropdown>
      <Dropdown.Toggle
        variant="light"
        id="dropdown-sort"
        className="d-flex align-items-center justify-content-between"
        style={{
          borderRadius: "12px",
          border: "1px solid #EBEBEB",
          padding: "6px 12px",
          backgroundColor: "white",
        }}
      >
        <span className="fs-12 fw-400 textGrey">{placeholder} :</span>
        <span className="d-flex align-items-center px-1">
          <span
            className="dropdown-text"
            title={value?.label || "Select"} // shows full text on hover
          >
            {value?.label || "Select"}
          </span>

          {/* <span className="dropdown-toggle-arrow textPurple">
            <DownArrow />
          </span> */}
          {value?.label && (
            <X
              size={16}
              className="ms-1 cursor-pointer"
              onClick={(e) => {
                e.stopPropagation(); // prevent dropdown toggle
                handleClear(); // your function to clear selection
              }}
            />
          )}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          border: "1px solid #EBEBEB",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          minWidth: "200px",
          overflowY: "auto",
          maxHeight: "220px",
        }}
      >
        <div style={{ padding: "8px" }}>
          <input
            type="text"
            className="fs-14 fw-500 textcolor"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={`Search ${placeholder}`}
            style={{
              width: "100%",
              padding: "6px 8px",
              borderRadius: "8px",
              border: "1px solid #EBEBEB",
            }}
          />
        </div>

        {loading ? (
          <Dropdown.Item disabled>Loading...</Dropdown.Item>
        ) : options.length === 0 ? (
          <Dropdown.Item disabled>No results found</Dropdown.Item>
        ) : (
          options.map((option) => (
            <Dropdown.Item
              className="fs-14 fw-500 textcolor"
              key={option.value}
              onClick={() => onSelect(option)}
              active={value?.value === option.value}
            >
              {option.label}
            </Dropdown.Item>
          ))
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SearchableDropdown;
